<section class="revenue">
  <h1 class="revenue-heading">Revenue Collection</h1>
  <form [formGroup]="form" class="revenue-form">
    <div class="row">
      <div class="row-col__md-6 form__group mb-4">
        <label for="reference" class="form-label">Billing Reference*</label>
        <input
          type="text"
          class="form__control"
          id="reference"
          formControlName="reference"
        />
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="agencyName" class="form-label">Agency Name*</label>
        <input
          type="text"
          class="form__control"
          id="agencyName"
          formControlName="agencyName"
        />
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="amountDue" class="form-label">Amount Due*</label>
        <input
          type="text"
          class="form__control"
          id="amount"
          formControlName="amount"
        />
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="payerName" class="form-label">Payer's Name*</label>
        <input
          type="text"
          class="form__control"
          id="payerName"
          formControlName="payerName"
        />
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="revName" class="form-label">Revenue Name*</label>
        <input
          type="text"
          class="form__control"
          id="revName"
          formControlName="revName"
        />
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="amountToPay" class="form-label">Amount To Pay*</label>
        <input
          type="text"
          class="form__control"
          id="amountToPay"
          formControlName="amountToPay"
          (keypress)="validateInput($event)"
          (blur)="formatInput($event)"
          (input)="removeCommas($event)"
        />
        <span class="charges ml-1">Service Charge: #{{ fee }}</span>
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="phoneNumber" class="form-label">Phone Number*</label>
        <input
          type="tel"
          class="form__control"
          id="phoneNumber"
          placeholder="Enter your phone number"
          formControlName="phoneNumber"
          (keypress)="validateInput($event)"
        />
      </div>
      <div class="row-col__md-6 form__group mb-4">
        <label for="email" class="form-label">Email*</label>
        <input
          type="email"
          class="form__control"
          id="email"
          placeholder="Enter your email"
          formControlName="email"
        />
      </div>
    </div>
  </form>
  <button class="btn btn__primary btn__md submit-btn" (click)="submit()">
    Submit
  </button>
</section>

<app-error-dialog
  [visible]="showModal"
  [message]="errorMessage"
  (closed)="showModal = false"
/>
